export default __webpack_public_path__ + "static/media/jnh3.b1252da0.jpg";